import { AccredibleButtonFilterComponentModule } from '@accredible-frontend-v2/new-components/button-filter';
import { AccredibleMultiSearchFilterModule } from '@accredible-frontend-v2/new-components/multi-search-filter';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AccredibleMultiSearchFilterMenuComponent } from './multi-search-filter-menu.component';

@NgModule({
  imports: [AccredibleButtonFilterComponentModule, AccredibleMultiSearchFilterModule, CommonModule],
  declarations: [AccredibleMultiSearchFilterMenuComponent],
  exports: [AccredibleMultiSearchFilterMenuComponent],
})
export class AccredibleMultiSearchFilterMenuModule {}
